import {configuration} from "../common/common.tsx";

export function randomIntFromInterval(min: number, max: number) { // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min)
}

export function getRootPath(){
    return `${configuration.apiPath}${configuration.apiEndpoint}`
}